PJQ.views.bidForms.Proposals = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposals'),
        subTemplates: {
            proposalLeveling: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Leveling'),
            levelProposalItem: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'level-proposal-item'),
            item: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Item'),
            itemTooltip: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Item-Tooltip')
        },
        canEdit: false,
        canSelect: false,
        isLeveling: true,
        isCompareMode: false
    },
    events: {
        "click .open-bidders-tab": "openBiddersTab",
        'click .proposals-compare': 'compareProposals',
        "click .proposals-export-excel": "exportExcel",
        "click .proposals-export-selected": "exportSelected",
        "click .proposals-export-select": "selectProposals",
        "click .proposals-cancel-select": "cancelSelect",
        "click .cb-alternate-enabled": "alternateEnabled",
        "click .btn-view-proposal": "viewProposal",
        "click .btn-reject-proposal": "rejectProposal",
        "click .btn-revise-proposal": "reviseProposal",
        "click .btn-award-proposal": "awardProposal",
        "click .btn-export-proposal-xlsx": "exportProposalExcelClicked",
        "click .btn-export-proposal-pdf": "exportProposalPDFClicked",
        "click .btn-delete-proposal": "deleteProposal",
        'keyup .proposals-search': 'filterProposals',
        'click .btn-export-all': 'exportExcel',
        'click .proposals-clear-filters': 'clearFilters',
        'click .btn-enable-leveling': 'enableLeveling',
        'click .btn-cancel-leveling': 'cancelLeveling',
        'click .btn-save-leveling': 'saveLeveling',
        'mousedown .proposal-item': 'levelItem',
        'keydown .item-cost': 'levelValueChanged',
        'keydown .item-note': 'levelValueChanged',
        'click .level-color-swatch': 'onSelectLevelColor',
        'click .btn-level-clear': 'clearActiveLevelItem',
        'click .btn-clear-proposal-leveling': 'clearProposalLeveling',
        'click .btn-reapply-proposal-leveling': 'reapplyPreviousLeveling',
        'change .proposals-toggle-adjustments': 'toggleDisplayAdjustments',
        "click .btn-toggle-compare-mode": "toggleCompareMode"
    },
    beforeFirstRender: function () {
        $('body').on('mousedown', _.bind(function (e) {
            if (!this.options.isLeveling) {
                return;
            }

            let $target = $(e.target);

            if ($target.closest('.level-proposal-item').length > 0) {
                return;
            }

            if ($target.closest('.proposal-item').length > 0) {
                return;
            }

            this.removeActiveLevelItem();
        }, this));

        this.options.showAdjustments = this.options.settings.get('isBidLevelingEnabled');
        this.search = "";
        this.options.isCompareMode = false;
        this.compareSelectedIds = [];
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
        this.listenTo(this.collection, "sync change update reset", this.render);

        this.options.isSealed = this.options.settings.get('isSealBids') === true || this.options.bidForm.get('isSealed') === true;

        // this.options.hideSealedValues = this.options.settings.get('isHideSealedValues');
        this.options.hideSealedValues = true;
    },
    renderData: function () {
        let proposals = []
        if (this.options.bidForm && this.options.bidForm.get('bidPackage') != null) {
            proposals = this.collection.getProposals(null);
        } else {
            proposals = this.collection.getProposals(this.options.bidForm.id);
        }
        _.each(proposals.models, function (proposal) {
            if (proposal.get('viewedOn') == null && proposal.get('submittedOn') != null) {
                proposal.updateViewed();
            }
        });

        return {
            canEdit: this.options.canEdit,
            canView: !this.options.settings.get('isSealBids') || !this.options.isSealed || this.options.settings.isSealedBidContact(PJQ.app.session.user.get('id')),
            collection: proposals,
            canSelect: this.options.canSelect,
            search: this.search,
            settings: this.options.settings,
            bidForm: this.options.bidForm,
            hideProposalValues: this.options.isSealed && this.options.hideSealedValues
        };
    },
    afterRender: function () {
        this.loadProposalSortFromStorage();

        this.statusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.proposals-status-filter'),
            onChange: _.bind(this.filterProposals, this),
            isMultiple: true,
            defaultValue: this.statusFilter,
            noneSelectedText: 'No Filters'
        });
        this.searchBar = this.$('.proposals-search');

        if (this.options.settings.get('isBidLevelingEnabled')) {
            this.sortByPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.proposals-sort-by'),
                onChange: _.bind(this.sortProposals, this),
                isMultiple: false,
                defaultValue: this.sortBy,
                noneSelectedText: 'Sort By'
            });

            // this.sortDirectionPicker = new PJQ.inputs.Selectpicker({
            //     el: this.$('.proposals-sort-direction'),
            //     onChange: _.bind(this.sortProposals, this),
            //     isMultiple: false,
            //     defaultValue: this.sortDir,
            //     noneSelectedText: 'Sort Direction'
            // });
        }

        this.renderProposals();

        this.$('.proposals-container').sortable({
            items: '.bid-form-proposal',
            connectWith: '.bid-form-proposal',
            update: _.bind(function () {
                this.changeSort();
            }, this)
        });
    },
    sortProposals: function () {
        let sortBy = String((this.sortByPicker && this.sortByPicker.getValue ? this.sortByPicker.getValue() : '') || '').trim();
        let sortDir = String((this.sortDirectionPicker && this.sortDirectionPicker.getValue ? this.sortDirectionPicker.getValue() : '') || '').trim();

        if (sortBy !== 'adjustedTotal' && sortBy !== 'submittedTotal') {
            sortBy = 'adjustedTotal';
        }
        if (sortDir !== 'asc' && sortDir !== 'desc') {
            sortDir = 'asc';
        }

        this.sortBy = sortBy;
        this.sortDir = sortDir;

        this.saveProposalSortToStorage();

        this.renderProposals(false);
    },
    changeSort: function () {
        let self = this,
            proposals = this.collection.getProposals(this.options.bidForm.id);
        this.$('.bid-form-proposal').each(function (index) {
            if (self.getSearchFilter().length === 0 && self.getStatusFilter().length === 0) {
                let proposal = proposals.get($(this).data('cid'));
                if (proposal) {
                    proposal.set('sortOrder', index + 1);
                    proposal.save();
                }
            }
        });
    },
    clearFilters: function () {
        this.statusFilterPicker.deselectAll();
        this.search = "";
        this.searchBar.val(this.search);
        this.filterProposals();
    },
    filterProposals: function () {
        this.statusFilter = this.statusFilterPicker.getValue();
        this.search = this.searchBar.val().trim();
        this.renderProposals();
    },
    selectProposals: function () {
        this.selectedIds = [];
        this.options.canSelect = true;
        this.exportToolbar = new PJQ.views.toolbars.ExportSelectedToolbar({
            el: this.$el,
            onExport: _.bind(function () {
                this.exportSelected();
                this.exportToolbar.destroy();
                this.cancelSelectProposals();
            }, this),
            onClose: _.bind(function () {
                this.cancelSelectProposals();
            }, this)
        });
        this.render();
    },
    cancelSelectProposals: function () {
        this.options.canSelect = false;
        this.render();
    },
    getFilteredProposals: function () {
        let proposals = [];
        if (this.options.bidForm && this.options.bidForm.get('bidPackage') != null) {
            proposals = this.collection.getProposals(null).models;
        } else {
            proposals = this.collection.getProposals(this.options.bidForm.id).models;
        }

        if (this.options.settings.get('isBidLevelingEnabled')) {
            /* 2024-09-18 Blue: are not filtering unsubmitted out of levelling mode at this time.
            proposals = _.filter(proposals, function (proposal) {
                return proposal.get('isSubmitted');
            });
            */
        }

        if (true) {
            let searchFilter = this.getSearchFilter().toLowerCase();
            if (searchFilter.length > 0) {
                proposals = _.filter(proposals, function (model) {
                    return null != _.find(model.bidder.contacts.models, function (contact) {
                        if (contact.get('email').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else if (contact.get('companyName').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else if (contact.get('contactName').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else {
                            let numSearch = PJQ.helpers.formatHelpers.numbersOnly(searchFilter);
                            if (_.size(numSearch) === 0)
                                return false;
                            if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('phone')).indexOf(numSearch) !== -1)
                                return true;
                            else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('fax')).indexOf(numSearch) !== -1)
                                return true;
                            else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('cell')).indexOf(numSearch) !== -1)
                                return true;
                        }
                    });
                });
            }

            let statusF = this.getStatusFilter();
            if (statusF.length > 0) {
                proposals = _.filter(proposals, function (model) {
                    let result = false;
                    if (statusF.indexOf('submitted') !== -1 && model.get('isSubmitted')) {
                        result = true;
                    } else if (statusF.indexOf('notsubmitted') !== -1 && !model.get('isSubmitted') && !model.get('isRejected')) {
                        result = true;
                    } else if (statusF.indexOf('rejected') !== -1 && model.get('isRejected')) {
                        result = true;
                    }

                    if (statusF.indexOf('locked') !== -1 && model.get('isLocked')) {
                        result = true;
                    } else if (statusF.indexOf('locked') !== -1 && !model.get('isLocked')) {
                        result = false;
                    }

                    if (statusF.indexOf('unlocked') !== -1 && !model.get('isLocked')) {
                        result = true;
                    } else if (statusF.indexOf('unlocked') !== -1 && model.get('isLocked')) {
                        result = false;
                    }

                    return result;
                }, this);
            }
        }

        return new PJQ.collections.bidForms.Proposals(proposals)
    },
    getCompareChoices: function () {
        let proposals = [];
        if (this.options.bidForm && this.options.bidForm.get('bidPackage') != null) {
            proposals = this.collection.getProposals(null).models;
        } else {
            proposals = this.collection.getProposals(this.options.bidForm.id).models;
        }

        let items = _.map(proposals, function (p) {
            let name = '';
            if (p.bidder && p.bidder.get) {
                name = `${p.bidder.get('companyName') || ''}`.trim();
            }
            if (name === '') name = `Proposal ${p.id}`;

            let submittedTotal = p.calculateTotal(true, true);
            let adjustedTotal = p.calculateTotal(true);

            return {
                id: p.id,
                name: `<div>${name}</div><div class="text-muted fs-12">Submitted: ${PJQ.helpers.formatHelpers.formatCurrency(submittedTotal, 2, true)}</div><div class="text-muted fs-12">Adjusted: ${PJQ.helpers.formatHelpers.formatCurrency(adjustedTotal, 2, true)}</div>`,
                title: name
            };
        });

        items = _.sortBy(items, function (x) {
            let n = parseFloat(x.adjustedTotal);
            return isNaN(n) ? Number.POSITIVE_INFINITY : n;
        });

        return items;
    },
    toggleCompareMode: function (e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (this.options.isCompareMode) {
            this.options.isCompareMode = false;
            this.compareSelectedIds = [];
            this.renderProposals(false, false);
            return;
        }

        this.options.isCompareMode = true;
        this.compareSelectedIds = [];
        this.removeActiveLevelItem({skipRender: true});
        this.renderProposals(false, false);
    },
    toggleDisplayAdjustments: function (e) {
        this.options.showAdjustments = $(e.currentTarget).is(':checked') === true;
        this.renderProposals(false);
    },
    makeProposalItemTooltip: function ($el) {
        let $item = $el.hasClass('proposal-item') ? $el : $el.find('.proposal-item').first();
        if ($item.length === 0) {
            $item = $el.closest('.proposal-item');
        }

        if ($item.length === 0 || !$item.hasClass('leveled')) {
            return;
        }

        let proposalId = $item.closest('.proposal-card').data('proposalId');
        let proposal = this.proposals && this.proposals.get ? this.proposals.get(proposalId) : null;
        if (!proposal) {
            return;
        }

        let pp = proposal.projectProposal || null;

        let kind = `${$item.data('kind') || ''}`.trim();
        let cid = $item.data('cid');

        let tryGet = (col) => {
            if (!col || !col.get) return null;
            return col.get(cid) || null;
        };

        let model = null;

        switch (kind) {
            case 'lineItem':
                model = tryGet(proposal.lineItems);
                break;
            case 'alternate':
                model = tryGet(proposal.alternates);
                break;
            case 'acknowledgement':
                model = tryGet(proposal.acknowledgements) || (pp ? tryGet(pp.acknowledgements) : null);
                break;
            case 'bonding':
                model = pp ? tryGet(pp.bonding) : null;
                break;
            case 'certification':
                model = pp ? tryGet(pp.certifications) : null;
                break;
            case 'laborRate':
                model = pp ? tryGet(pp.laborRates) : null;
                break;
            case 'inclusions':
            case 'exclusions':
                model = proposal;
                break;
        }

        if (!model) {
            return;
        }

        let getChoiceModels = (m) => {
            if (m && m.choices && _.isArray(m.choices.models)) return m.choices.models;
            if (m && _.isArray(m.choices)) return m.choices;
            if (m && m.get && _.isArray(m.get('choices'))) return m.get('choices');
            return [];
        };

        let buildChoiceMap = (m) => {
            let list = getChoiceModels(m);
            return _.reduce(list, function (map, c) {
                if (!c) return map;

                let id = c.get ? c.get('id') : c.id;
                if (id == null) return map;

                let n = parseInt(id, 10);
                if (isNaN(n)) return map;

                let v = c.get ? c.get('value') : c.value;
                map[n] = v != null ? `${v}` : '';
                return map;
            }, {});
        };

        let formatByType = (typeName, rawValue, m) => {
            let t = `${typeName || ''}`.trim().toLowerCase();
            let v = rawValue == null ? '' : `${rawValue}`.trim();

            if (t === 'yes/no') {
                let vv = v.toLowerCase();
                if (vv === 'yes') return 'Yes';
                if (vv === 'no') return 'No';
                return v;
            }

            if (t === 'date' || t === 'date/time') {
                if (v === '') return '';
                let d = new Date(v);
                if (isNaN(d.getTime())) return v;
                return PJQ.helpers.dateHelpers.getDateString(
                    d,
                    t === 'date' ? PJQ.helpers.dateHelpers.dateFormats.DATE : PJQ.helpers.dateHelpers.dateFormats.DATE_TIME
                );
            }

            if (t === 'money') {
                if (v === '') return '';
                if (/^-?\d+$/.test(v)) {
                    let cents = parseInt(v, 10);
                    if (!isNaN(cents)) return PJQ.helpers.formatHelpers.formatCurrency(cents);
                }
                let cleaned = v.replace(/[^0-9.\-]/g, '');
                let dollars = parseFloat(cleaned);
                if (isNaN(dollars)) return v;
                return PJQ.helpers.formatHelpers.formatCurrency(Math.round(dollars * 100));
            }

            if (t === 'single choice') {
                let map = buildChoiceMap(m);
                let n = parseInt(v, 10);
                if (!isNaN(n) && map[n] != null && `${map[n]}`.trim() !== '') return `${map[n]}`;
                return v;
            }

            if (t === 'multiple choice') {
                let map = buildChoiceMap(m);
                if (v === '') return '';
                let ids = _.filter(_.map(v.split('|'), function (x) {
                    return `${x}`.trim();
                }), function (x) {
                    return x !== '';
                });
                let labels = _.filter(_.map(ids, function (id) {
                    let n = parseInt(id, 10);
                    if (isNaN(n)) return null;
                    let out = map[n];
                    out = out == null ? '' : `${out}`.trim();
                    return out !== '' ? out : null;
                }), function (x) {
                    return x != null;
                });
                return labels.length > 0 ? labels.join(', ') : v;
            }

            return v;
        };

        let submittedLabel = 'Submitted Value';
        let submittedText = '';
        let note = '';

        if (kind === 'inclusions') {
            submittedText = `${model.get('inclusions') || ''}`;
            note = '';
        } else if (kind === 'exclusions') {
            submittedText = `${model.get('exclusions') || ''}`;
            note = '';
        } else if (kind === 'lineItem' || kind === 'alternate') {
            let typeName = `${model.get('type') || ''}`;

            let isQuestion = (kind === 'lineItem')
                ? PJQ.helpers.bidForms.lineItemQuestionTypes.indexOf(typeName) !== -1
                : PJQ.helpers.bidForms.alternateQuestionTypes.indexOf(typeName) !== -1;

            if (!isQuestion) {
                submittedLabel = 'Submitted Cost';
                let cost = model.get('cost');
                let mult = model.get('multiplier');
                let total = (mult != null && mult > 0 ? (mult * cost) : cost);
                submittedText = PJQ.helpers.formatHelpers.formatCurrency(total);
                note = `${model.get('note') || ''}`;
            } else {
                submittedLabel = 'Submitted Value';
                submittedText = formatByType(typeName, model.get('answer'), model);
                note = `${model.get('note') || ''}`;
            }
        } else {
            let typeName = `${model.get('type') || ''}`;

            submittedLabel = 'Submitted Value';
            submittedText = formatByType(typeName, model.get('value'), model);
            note = `${model.get('note') || ''}`;
        }

        new PJQ.Tooltip($item, {
            template: this.options.subTemplates.itemTooltip,
            container: this.$el,
            trigger: 'hover',
            renderData: _.bind(function () {
                return {
                    submittedLabel: submittedLabel,
                    submittedText: submittedText,
                    note: note
                };
            }, this)
        });
    },
    makeProposalItem: function (proposalItem) {
        let itemClass, isAlternate = false, levelKind = '';

        if (proposalItem.get('bidFormAlternateId') != null) {
            itemClass = 'proposal-alternate';
            isAlternate = true;
            levelKind = 'alternate';
        } else if (proposalItem.get('bidFormLineItemId') != null) {
            itemClass = 'proposal-line-item';
            levelKind = 'lineItem';
        } else if (proposalItem.get('bidFormAcknowledgementId') != null) {
            itemClass = 'proposal-ack-item';
            levelKind = 'acknowledgement';
        } else if (proposalItem.get('bidFormBondingId') != null) {
            itemClass = 'proposal-bonding-item';
            levelKind = 'bonding';
        } else if (proposalItem.get('bidFormCertificationId') != null) {
            itemClass = 'proposal-certification-item';
            levelKind = 'certification';
        } else if (proposalItem.get('bidFormLaborRateId') != null) {
            itemClass = 'proposal-labor-rate-item';
            levelKind = 'laborRate';
        } else {
            return $('<div></div>');
        }

        let isQuestion = false;
        if (levelKind === 'lineItem') {
            isQuestion = PJQ.helpers.bidForms.lineItemQuestionTypes.indexOf(proposalItem.get('type')) !== -1;
        } else if (levelKind === 'alternate') {
            isQuestion = PJQ.helpers.bidForms.alternateQuestionTypes.indexOf(proposalItem.get('type')) !== -1;
        }

        let itemTypeList = (levelKind === 'alternate') ? PJQ.helpers.bidForms.alternateTypes : PJQ.helpers.bidForms.lineItemTypes;

        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.item, {
            isQuestion: isQuestion,
            itemClass: itemClass,
            isAlternate: isAlternate,
            proposalItem: proposalItem,
            showAdjustments: this.options.showAdjustments,
            levelKind: levelKind,
            itemTypeList: itemTypeList
        });
    },
    getLevelTargetFromElement: function ($target) {
        let proposalId = $target.closest('.proposal-card').data('proposalId');
        let proposal = this.proposals.get(proposalId);
        if (!proposal) {
            return null;
        }

        let itemCid = $target.data('cid');
        let kind = null;
        let model = null;

        let tryGet = (col) => {
            if (!col || !col.get) return null;
            return col.get(itemCid) || null;
        };

        let pp = proposal.projectProposal || null;

        if ($target.hasClass('proposal-line-item')) {
            kind = 'lineItem';
            model = tryGet(proposal.lineItems);
        } else if ($target.hasClass('proposal-alternate')) {
            kind = 'alternate';
            model = tryGet(proposal.alternates);
        } else if ($target.hasClass('proposal-ack-item')) {
            kind = 'acknowledgement';
            model = tryGet(proposal.acknowledgements) || (pp ? tryGet(pp.acknowledgements) : null);
        } else if ($target.hasClass('proposal-bonding-item')) {
            kind = 'bonding';
            model = tryGet(proposal.bonding) || (pp ? tryGet(pp.bonding) : null);
        } else if ($target.hasClass('proposal-certification-item')) {
            kind = 'certification';
            model = tryGet(proposal.certifications) || (pp ? tryGet(pp.certifications) : null);
        } else if ($target.hasClass('proposal-labor-rate-item')) {
            kind = 'laborRate';
            model = tryGet(proposal.laborRates) || (pp ? tryGet(pp.laborRates) : null);
        } else if ($target.hasClass('proposal-inclusions-item')) {
            kind = 'inclusions';
            model = proposal;
        } else if ($target.hasClass('proposal-exclusions-item')) {
            kind = 'exclusions';
            model = proposal;
        }

        if (!kind || !model) {
            return null;
        }

        let fields = this.getLevelFields(kind, model);
        if (!fields) {
            return null;
        }

        return {
            proposal: proposal,
            kind: kind,
            model: model,
            fields: fields
        };
    },
    getLevelFields: function (kind, model) {
        let type = String(model && model.get ? model.get('type') : '').trim();
        let mode = this.getLevelModeForType(type);

        if (kind === 'lineItem') {
            if (mode) {
                return {
                    mode: mode,
                    valueField: 'leveledAnswer',
                    baseValueField: 'answer',
                    bgField: 'leveledBgColor',
                    noteField: null,
                    costField: null,
                    multField: null
                };
            }

            return {
                mode: 'costMult',
                valueField: null,
                bgField: 'leveledBgColor',
                noteField: 'note',
                costField: 'leveledCost',
                multField: 'leveledMultiplier'
            };
        }

        if (kind === 'alternate') {
            if (mode) {
                return {
                    mode: mode,
                    valueField: 'leveledAnswer',
                    baseValueField: 'answer',
                    bgField: 'leveledBgColor',
                    noteField: null,
                    costField: null,
                    multField: null
                };
            }

            return {
                mode: 'costMult',
                valueField: null,
                bgField: 'leveledBgColor',
                noteField: 'note',
                costField: 'leveledCost',
                multField: 'leveledMultiplier'
            };
        }

        if (kind === 'acknowledgement' || kind === 'bonding' || kind === 'certification' || kind === 'laborRate') {
            if (mode) {
                return {
                    mode: mode,
                    valueField: 'leveledValue',
                    baseValueField: 'value',
                    bgField: 'leveledBgColor',
                    noteField: null,
                    costField: null,
                    multField: null
                };
            }

            return {
                mode: 'text',
                valueField: 'leveledValue',
                baseValueField: 'value',
                bgField: 'leveledBgColor',
                noteField: null,
                costField: null,
                multField: null
            };
        }

        if (kind === 'inclusions') {
            return {
                mode: 'textarea',
                valueField: 'leveledInclusions',
                baseValueField: 'inclusions',
                bgField: 'leveledInclusionsBgColor',
                noteField: null,
                costField: null,
                multField: null
            };
        }

        if (kind === 'exclusions') {
            return {
                mode: 'textarea',
                valueField: 'leveledExclusions',
                baseValueField: 'exclusions',
                bgField: 'leveledExclusionsBgColor',
                noteField: null,
                costField: null,
                multField: null
            };
        }

        return null;
    },
    removeActiveLevelItem: function (options) {
        options = options || {};

        this.saveActiveLevelItem({
            skipRender: options.skipRender === true
        });

        this.$('.proposal-item.is-level-editing').removeClass('is-level-editing');

        if (this.levelValuePicker) {
            this.levelValuePicker.remove();
            this.levelValuePicker = null;
        }

        this.$('.level-proposal-item').remove();
        this.contextProposal = null;
        this.contextLevelItem = null;
        this.contextLevelTarget = null;
    },
    saveActiveLevelItem: function (options) {
        options = options || {};

        let $active = this.$('.level-proposal-item');
        if ($active.length === 0 || !this.contextLevelTarget) {
            return;
        }

        let target = this.contextLevelTarget;
        let fields = target.fields;
        let model = target.model;

        let changed = false;

        if (fields.mode === 'costMult') {
            let rawCost = `${$active.find('.item-cost').val() || ''}`.trim();
            let nextLeveledCost = null;

            if (rawCost.length === 0) {
                nextLeveledCost = 0;
            } else {
                rawCost = rawCost.replace(/[^0-9.\-]/g, '');
                let dollars = parseFloat(rawCost);
                if (!isNaN(dollars)) {
                    nextLeveledCost = Math.round(dollars * 100);
                }
            }

            let nextLeveledMultiplier = null;

            if (!this.isSumType(model.get('type'))) {
                let rawMult = `${$active.find('.item-multiplier').val() || ''}`.trim();

                if (rawMult.length === 0) {
                    nextLeveledMultiplier = 0;
                } else {
                    rawMult = rawMult.replace(/[^0-9.\-]/g, '');
                    let qty = parseFloat(rawMult);
                    if (!isNaN(qty)) {
                        nextLeveledMultiplier = qty;
                    }
                }
            }

            let baseCost = model.get('cost');
            let baseMult = model.get('multiplier');

            if (this.isSumType(model.get('type'))) {
                if (baseCost === nextLeveledCost) {
                    nextLeveledCost = null;
                }
                nextLeveledMultiplier = null;
            } else {
                if (baseCost === nextLeveledCost && (nextLeveledMultiplier == null || baseMult === nextLeveledMultiplier)) {
                    nextLeveledCost = null;
                    nextLeveledMultiplier = null;
                }
            }

            let nextNote = null;
            if (fields.noteField) {
                let note = $active.find('.item-note').val() || '';
                note = `${note}`.trim();
                nextNote = note.length > 0 ? note : '';
            }

            let currentLeveledCost = model.get(fields.costField);
            let currentLeveledMultiplier = model.get(fields.multField);
            let currentNote = fields.noteField ? (model.get(fields.noteField) || '') : null;

            let setObj = {};

            if (currentLeveledCost !== nextLeveledCost) {
                setObj[fields.costField] = nextLeveledCost;
                changed = true;
            }

            if (currentLeveledMultiplier !== nextLeveledMultiplier) {
                setObj[fields.multField] = nextLeveledMultiplier;
                changed = true;
            }

            if (fields.noteField && currentNote !== nextNote) {
                setObj[fields.noteField] = nextNote;
                changed = true;
            }

            if (changed) {
                model.set(setObj);
            }
        } else if (fields.valueField) {
            let mode = fields.mode;

            let normalize = (val) => {
                switch (mode) {
                    case 'multipleChoice': {
                        let arr = [];

                        if (_.isArray(val)) {
                            arr = val;
                        } else if (val != null && `${val}`.trim() !== '') {
                            arr = `${val}`.split('|');
                        }

                        arr = _.map(arr, function (x) {
                            let n = parseInt(x, 10);
                            return isNaN(n) ? null : n;
                        });
                        arr = _.filter(arr, function (x) {
                            return x != null;
                        });
                        arr = _.uniq(arr);
                        arr = _.sortBy(arr, function (x) {
                            return x;
                        });

                        return arr.length > 0 ? arr.join('|') : '';
                    }

                    case 'singleChoice': {
                        if (val == null || `${val}`.trim() === '') return '';
                        let n = parseInt(val, 10);
                        return isNaN(n) ? '' : `${n}`;
                    }

                    case 'yesNo': {
                        val = val == null ? '' : `${val}`.trim();
                        if (val !== 'yes' && val !== 'no') return '';
                        return val;
                    }

                    case 'date':
                    case 'dateTime': {
                        if (val == null || `${val}`.trim() === '') return '';
                        let d = new Date(val);
                        return isNaN(d.getTime()) ? '' : d.toISOString();
                    }

                    case 'money': {
                        if (val == null) return '';
                        let s = `${val}`.trim();

                        if (s === '') return '0';

                        if (/^-?\d+$/.test(s)) {
                            return s;
                        }

                        s = s.replace(/[^0-9.\-]/g, '');
                        let n = parseFloat(s);
                        if (isNaN(n)) return '0';
                        return `${Math.round(n * 100)}`;
                    }

                    case 'numeric': {
                        if (val == null) return '';
                        let s = `${val}`.trim();
                        if (s === '') return '0';
                        s = s.replace(/[^0-9.\-]/g, '');
                        let n = parseFloat(s);
                        if (isNaN(n)) return '0';
                        return `${n}`;
                    }

                    default:
                        return val == null ? '' : `${val}`.trim();
                }
            };

            let valuesEqual = (a, b) => {
                return normalize(a) === normalize(b);
            };

            let getEditorValue = () => {
                switch (mode) {
                    case 'textarea':
                        return `${$active.find('.item-textarea').val() || ''}`.trim();

                    case 'date':
                        return $active.find('.item-date').data('iso') || null;

                    case 'dateTime':
                        return $active.find('.item-datetime').data('iso') || null;

                    case 'multipleChoice': {
                        if (this.levelValuePicker && this.levelValuePicker.getValue) {
                            let v = this.levelValuePicker.getValue();
                            return _.isArray(v) ? v : [];
                        }
                        let v = $active.find('.item-value').val();
                        return _.isArray(v) ? v : [];
                    }

                    case 'yesNo':
                    case 'singleChoice': {
                        if (this.levelValuePicker && this.levelValuePicker.getValue) {
                            return this.levelValuePicker.getValue();
                        }
                        return $active.find('.item-value').val();
                    }

                    case 'money': {
                        let $m = $active.find('.item-money').first();
                        if ($m.length === 0) {
                            return '0';
                        }

                        let raw = '';

                        if ($m.inputmask) {
                            raw = $m.inputmask('unmaskedvalue');
                        }

                        raw = raw == null ? '' : `${raw}`.trim();

                        if (raw === '') {
                            return '0';
                        }

                        let dollars = parseFloat(raw);
                        if (isNaN(dollars)) {
                            return '0';
                        }

                        return `${Math.round(dollars * 100)}`;
                    }

                    case 'numeric': {
                        let v = `${$active.find('.item-numeric').val() || ''}`.trim();
                        if (v === '') return '0';
                        v = v.replace(/[^0-9.\-]/g, '');
                        let n = parseFloat(v);
                        if (isNaN(n)) return '0';
                        return `${n}`;
                    }

                    default:
                        return `${$active.find('.item-value').val() || ''}`.trim();
                }
            };

            let currentLeveled = model.get(fields.valueField);
            let baseValue = fields.baseValueField ? model.get(fields.baseValueField) : null;

            let displayCurrent = normalize(currentLeveled != null ? currentLeveled : baseValue);
            let nextValue = normalize(getEditorValue());
            let baseNorm = normalize(baseValue);

            if (valuesEqual(nextValue, displayCurrent)) {
                return;
            }

            let setObj = {};

            if (fields.baseValueField && valuesEqual(nextValue, baseNorm)) {
                setObj[fields.valueField] = null;
            } else {
                setObj[fields.valueField] = nextValue;
            }

            model.set(setObj);
            changed = true;
        } else {
            return;
        }

        if (!changed) {
            return;
        }

        if (!_.some(this.leveledProposals, function (prop) {
            return prop.id === target.proposal.id;
        })) {
            this.leveledProposals.push(target.proposal);
        }

        if (!options.skipRender) {
            this.renderProposals(false);
        }

        this.queueSaveLevelingChanges();
    },
    getLevelModeForType: function (type) {
        type = type.trim().toLowerCase();

        switch (type) {
            case 'yes/no':
                return 'yesNo';
            case 'text':
                return 'text';
            case 'textarea':
                return 'textarea';
            case 'money':
                return 'money';
            case 'numeric':
                return 'numeric';
            case 'single choice':
                return 'singleChoice';
            case 'multiple choice':
                return 'multipleChoice';
            case 'date':
                return 'date';
            case 'date/time':
                return 'dateTime';
            default:
                return null;
        }
    },
    levelValueChanged: function (e) {
        if (e.key === 'Enter') {
            this.removeActiveLevelItem();
        }
    },
    clearActiveLevelItem: function () {
        if (!this.contextLevelTarget || !this.contextLevelTarget.fields) {
            return;
        }

        let target = this.contextLevelTarget;
        let fields = target.fields;
        let model = target.model;

        let setObj = {};

        if (fields.mode === 'costMult') {
            if (fields.costField)
                setObj[fields.costField] = null;
            if (fields.multField)
                setObj[fields.multField] = null;
            if (fields.noteField)
                setObj[fields.noteField] = '';
        } else {
            if (fields.valueField)
                setObj[fields.valueField] = null;
        }

        if (fields.bgField) {
            setObj[fields.bgField] = null;
        }

        let normalize = (val) => {
            if (_.isArray(val)) {
                return _.sortBy(_.map(val, function (x) {
                    return `${x}`;
                }), function (x) {
                    return x;
                });
            }

            if (val === null) return '__NULL__';
            if (val === undefined) return '__UNDEFINED__';

            return `${val}`;
        };

        let hasActualChange = false;
        _.each(setObj, function (val, key) {
            let current = model.get(key);

            let a = normalize(current);
            let b = normalize(val);

            if (_.isArray(a) || _.isArray(b)) {
                if (!_.isArray(a)) a = [];
                if (!_.isArray(b)) b = [];
                if (a.length !== b.length || _.some(a, function (x, i) {
                    return x !== b[i];
                })) {
                    hasActualChange = true;
                }
            } else {
                if (a !== b) {
                    hasActualChange = true;
                }
            }
        });

        if (!hasActualChange) {
            this.removeActiveLevelItem({skipRender: true});
            return;
        }

        model.set(setObj);

        if (!_.some(this.leveledProposals, function (prop) {
            return prop.id === target.proposal.id;
        })) {
            this.leveledProposals.push(target.proposal);
        }

        this.renderProposals(false);
        this.queueSaveLevelingChanges();
    },
    levelItem: function (e) {
        e.stopPropagation();

        if (!this.options.isLeveling || !this.options.showAdjustments) {
            return;
        }

        let $target = $(e.currentTarget).closest('.proposal-item');
        if ($target.length === 0) {
            return;
        }

        let target = this.getLevelTargetFromElement($target);
        if (!target) {
            return;
        }

        let isSameTarget =
            this.contextLevelTarget != null &&
            this.contextLevelTarget.kind === target.kind &&
            this.contextLevelTarget.proposal != null &&
            this.contextLevelTarget.proposal.id === target.proposal.id &&
            this.contextLevelTarget.model != null &&
            this.contextLevelTarget.model.cid === target.model.cid;

        let hasActiveEditor = this.$('.level-proposal-item').length > 0;

        if (hasActiveEditor && !isSameTarget) {
            this.removeActiveLevelItem({skipRender: false});
        }

        if (isSameTarget) {
            let $existing = $target.find('.level-proposal-item');

            if ($existing.length > 0) {
                let $focus = $existing.find('.item-cost, .item-textarea, .item-value, .item-note').first();
                if ($focus.length > 0) {
                    $focus.focus();
                }
                return;
            }

            this.contextLevelTarget = null;
            this.contextProposal = null;
            this.contextLevelItem = null;
        }

        this.removeActiveLevelItem({
            skipRender: true
        });

        this.contextLevelTarget = target;
        this.contextProposal = target.proposal;
        this.contextLevelItem = target.model;

        let isSum = String(target.model.get('type') || '').toLowerCase() === 'sum';
        let cost = target.model.get('leveledCost') != null ? target.model.get('leveledCost') : target.model.get('cost');
        let note = target.model.get('note') ? target.model.get('note') : '';
        let multiplierValue = '';
        let value = '';

        if (target.fields.mode === 'costMult' && !isSum) {
            let m = target.model.get('leveledMultiplier') != null ? target.model.get('leveledMultiplier') : target.model.get('multiplier');
            multiplierValue = (m != null ? m : '');
        }

        if (target.fields.valueField) {
            let v = target.model.get(target.fields.valueField);
            if (v == null && target.fields.baseValueField) {
                v = target.model.get(target.fields.baseValueField);
            }
            value = v != null ? v : '';
        }

        let choices = target.model.choices || (target.model.get && target.model.get('choices')) || [];

        let $out = $('<div></div>');

        this.$('.proposal-item.is-level-editing').removeClass('is-level-editing');
        $target.addClass('is-level-editing');

        this.renderSubTemplate(true, this.options.subTemplates.levelProposalItem, $out, {
            mode: target.fields.mode,
            type: String(target.model.get('type') || ''),
            levelItem: target.model,
            cost: cost,
            note: note,
            leveledMultiplierValue: multiplierValue,
            isSum: isSum,
            value: value,
            choices: choices,
            hideProposalValues: this.options.isSealed && this.options.hideSealedValues
        }, _.bind(function () {
            $target.css({position: 'relative'});
            $target.append($out.children());

            let $active = $target.find('.level-proposal-item'),
                $cost = $active.find('.item-cost'),
                $mult = $active.find('.item-multiplier'),
                $textarea = $active.find('.item-textarea');

            if ($cost.length > 0) {
                PJQ.helpers.inputHelpers.inputMaskCurrency($cost, 2);
                $cost.focus();
            } else if ($textarea.length > 0) {
                $textarea.focus();
            }

            if ($mult.length > 0) {
                PJQ.helpers.inputHelpers.inputMaskInteger($mult);
            }

            let mode = target.fields.mode;

            if ($active.find('.item-money').length > 0) {
                PJQ.helpers.inputHelpers.inputMaskCurrency($active.find('.item-money'), 2, true);
            }

            if ($active.find('.item-numeric').length > 0) {
                PJQ.helpers.inputHelpers.inputMaskInteger($active.find('.item-numeric'));
            }

            let setDateDisplay = ($el, iso, format) => {
                if (!iso) {
                    $el.data('iso', null);
                    $el.val('');
                    return;
                }

                let d = new Date(iso);
                if (isNaN(d.getTime())) {
                    $el.data('iso', null);
                    $el.val('');
                    return;
                }

                $el.data('iso', d.toISOString());
                $el.val(PJQ.helpers.dateHelpers.getDateString(d, format));
            };

            let $date = $active.find('.item-date');
            if ($date.length > 0) {
                let iso = value;
                if (iso == null && target.fields.baseValueField) {
                    iso = target.model.get(target.fields.baseValueField);
                }

                setDateDisplay($date, iso, PJQ.helpers.dateHelpers.dateFormats.DATE);

                new PJQ.inputs.Datepicker({
                    el: $date,
                    isShowTimezone: false,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
                    },
                    onChange: _.bind(function (d) {
                        if (d && !isNaN(d.getTime())) {
                            $date.data('iso', d.toISOString());
                            $date.val(PJQ.helpers.dateHelpers.getDateString(d, PJQ.helpers.dateHelpers.dateFormats.DATE));
                        } else {
                            $date.data('iso', null);
                        }
                    }, this)
                });
            }

            let $dateTime = $active.find('.item-datetime');
            if ($dateTime.length > 0) {
                let iso = value;
                if (iso == null && target.fields.baseValueField) {
                    iso = target.model.get(target.fields.baseValueField);
                }

                setDateDisplay($dateTime, iso, PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);

                new PJQ.inputs.Datepicker({
                    el: $dateTime,
                    isShowTimezone: false,
                    datepickerOptions: {
                        format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME
                    },
                    onChange: _.bind(function (d) {
                        if (d && !isNaN(d.getTime())) {
                            $dateTime.data('iso', d.toISOString());
                            $dateTime.val(PJQ.helpers.dateHelpers.getDateString(d, PJQ.helpers.dateHelpers.dateFormats.DATE_TIME));
                        } else {
                            $dateTime.data('iso', null);
                        }
                    }, this)
                });
            }

            if (mode === 'yesNo' || mode === 'singleChoice' || mode === 'multipleChoice') {
                this.levelValuePicker = null;

                let rawValue = value;
                if (rawValue == null && target.fields.baseValueField) {
                    rawValue = target.model.get(target.fields.baseValueField);
                }

                let pickerChoices = [];
                let noneSelectedText = 'Select';

                if (mode === 'yesNo') {
                    pickerChoices = [
                        {id: 'yes', name: 'Yes'},
                        {id: 'no', name: 'No'}
                    ];

                    let dv = rawValue == null ? null : String(rawValue);
                    if (dv !== 'yes' && dv !== 'no') dv = null;

                    this.levelValuePicker = new PJQ.inputs.Selectpicker({
                        el: $active.find('.item-selectpicker'),
                        choices: pickerChoices,
                        defaultValue: dv,
                        canEdit: true,
                        isMultiple: false,
                        isIntChoices: false,
                        noneSelectedText: noneSelectedText,
                        onChange: () => {
                        }
                    });
                }

                if (mode === 'singleChoice') {
                    pickerChoices = _.map(choices?.models || [], function (c) {
                        return {id: c.id, name: c.get('value')};
                    });

                    let dv = rawValue;
                    if (dv == null || String(dv).trim() === '') dv = null;

                    let asInt = parseInt(dv, 10);
                    dv = !isNaN(asInt) ? asInt : null;

                    this.levelValuePicker = new PJQ.inputs.Selectpicker({
                        el: $active.find('.item-selectpicker'),
                        choices: pickerChoices,
                        defaultValue: dv,
                        canEdit: true,
                        isMultiple: false,
                        isIntChoices: true,
                        noneSelectedText: noneSelectedText,
                        onChange: () => {
                        }
                    });
                }

                if (mode === 'multipleChoice') {
                    pickerChoices = _.map(choices?.models || [], function (c) {
                        return {id: c.id, name: c.get('value')};
                    });

                    let dvArr = [];
                    if (rawValue != null && String(rawValue).trim() !== '') {
                        dvArr = _.filter(String(rawValue).split('|'), function (x) {
                            return String(x).trim() !== '';
                        });
                        dvArr = _.map(dvArr, function (x) {
                            let n = parseInt(x, 10);
                            return isNaN(n) ? null : n;
                        });
                        dvArr = _.filter(dvArr, function (x) {
                            return x != null;
                        });
                    }

                    this.levelValuePicker = new PJQ.inputs.Selectpicker({
                        el: $active.find('.item-selectpicker'),
                        choices: pickerChoices,
                        defaultValue: dvArr,
                        canEdit: true,
                        isMultiple: true,
                        isIntChoices: true,
                        noneSelectedText: noneSelectedText,
                        onChange: () => {
                        }
                    });
                }
            }

            let $val = $active.find('.item-value');
            if ($val.length > 0 && !$cost.length && !$textarea.length) {
                $val.first().focus();
            }
        }, this));
    },
    getScrollState: function () {
        let $sc = this.$('.proposals-scroll');
        if ($sc.length === 0) return null;
        return {top: $sc.scrollTop(), left: $sc.scrollLeft()};
    },

    applyScrollState: function (state) {
        if (!state) return;
        let $sc = this.$('.proposals-scroll');
        if ($sc.length === 0) return;
        $sc.scrollTop(state.top);
        $sc.scrollLeft(state.left);
    },
    onSelectLevelColor: function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.contextLevelTarget || !this.contextLevelTarget.fields) {
            return;
        }

        let target = this.contextLevelTarget;
        let bgField = target.fields.bgField;

        if (!bgField) {
            return;
        }

        let $swatch = $(e.currentTarget);
        let color = String($swatch.data('color') || '').replace('#', '');
        let currentColor = String(target.model.get(bgField) || '').replace('#', '');

        if (currentColor === color) {
            return;
        }

        let setObj = {};
        setObj[bgField] = color;
        target.model.set(setObj);

        if (!_.some(this.leveledProposals, function (prop) {
            return prop.id === target.proposal.id;
        })) {
            this.leveledProposals.push(target.proposal);
        }

        let $row = $swatch.closest('.proposal-item');
        $row.addClass('leveled');
        $row.css('background-color', '#' + color);

        $swatch.closest('.level-color-row').find('.level-color-swatch').removeClass('is-selected');
        $swatch.addClass('is-selected');

        this.queueSaveLevelingChanges();
    },
    enableLeveling: function () {
        this.options.showAdjustments = true;
        this.options.isLeveling = true;
        this.renderProposals();
    },
    cancelLeveling: function () {
        this.options.isLeveling = false;
        this.renderProposals();
    },
    queueSaveLevelingChanges: function () {
        if (this.saveTimeout != null) {
            clearTimeout(this.saveTimeout);
        }

        this.saveTimeout = setTimeout(() => {
            this.saveLevelingChanges();
        }, 3000)
    },
    saveLevelingChanges: function () {
        _.each(this.leveledProposals, (proposal) => {
            proposal.beforeSave();
        });

        let obj = {
            proposals: this.leveledProposals
        }
        this.leveledProposals = [];

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'proposals'
                },
                {
                    endpoint: 'level'
                }
            ]),
            data: obj
        }).patch().done(() => {

        });
    },
    saveLeveling: function () {
        this.options.isLeveling = false;
        _.each(this.leveledProposals, (proposal) => {
            proposal.beforeSave();
        });

        let obj = {
            proposals: this.leveledProposals
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'proposals'
                },
                {
                    endpoint: 'level'
                }
            ]),
            data: obj
        }).patch().done(_.bind(function (response) {
            this.renderProposals();
        }, this));
    },
    isSumType: function (type) {
        return String(type || '').toLowerCase() === 'sum';
    },
    // clearAllProposalLeveling: function () {
    //     this.leveledProposals = [];
    //
    //     this.proposals.each(_.bind(function (proposal) {
    //         let changed = false;
    //
    //         if (proposal.lineItems) {
    //             proposal.lineItems.each(function (li) {
    //                 let needsClear =
    //                     (li.get('note') || '') !== '' ||
    //                     li.get('leveledBgColor') != null ||
    //                     li.get('leveledCost') != null ||
    //                     li.get('leveledMultiplier') != null;
    //
    //                 if (needsClear) {
    //                     changed = true;
    //                     li.set({
    //                         note: '',
    //                         leveledBgColor: null,
    //                         leveledCost: null,
    //                         leveledMultiplier: null
    //                     }, { silent: true });
    //                 }
    //             });
    //         }
    //
    //         if (proposal.alternates) {
    //             proposal.alternates.each(function (alt) {
    //                 let needsClear =
    //                     (alt.get('note') || '') !== '' ||
    //                     alt.get('leveledBgColor') != null ||
    //                     alt.get('leveledCost') != null ||
    //                     alt.get('leveledMultiplier') != null;
    //
    //                 if (needsClear) {
    //                     changed = true;
    //                     alt.set({
    //                         note: '',
    //                         leveledBgColor: null,
    //                         leveledCost: null,
    //                         leveledMultiplier: null
    //                     }, { silent: true });
    //                 }
    //             });
    //         }
    //
    //         if (changed) {
    //             proposal.trigger('change');
    //             this.leveledProposals.push(proposal);
    //         }
    //     }, this));
    //
    //     this.renderProposals(false);
    // },
    clearProposalLeveling: function (e) {
        e.stopPropagation();

        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            proposal = this.proposals.get(proposalId);

        if (!proposal) {
            return;
        }

        new PJQ.views.modals.DeleteCancel({
            header: 'Confirm Clearing',
            body: 'Are you sure you want to clear all levels for this proposal? This cannot be undone.',
            onDelete: _.bind(function () {
                let resetCollection = function (collection, values) {
                    if (!collection) {
                        return;
                    }

                    collection.each(function (model) {
                        model.set(values);
                    });
                };

                let resetCostItems = {
                    note: '',
                    leveledBgColor: null,
                    leveledCost: null,
                    leveledMultiplier: null,
                    leveledAnswer: null
                };

                let resetValueItems = {
                    leveledValue: null,
                    leveledBgColor: null
                };

                resetCollection(proposal.lineItems, resetCostItems);
                resetCollection(proposal.alternates, resetCostItems);
                resetCollection(proposal.acknowledgements, resetValueItems);

                let pp = proposal.projectProposal;

                resetCollection(pp?.acknowledgements, resetValueItems);
                resetCollection(pp?.bonding, resetValueItems);
                resetCollection(pp?.certifications, resetValueItems);
                resetCollection(pp?.laborRates, resetValueItems);

                proposal.set({
                    leveledInclusions: null,
                    leveledInclusionsBgColor: null,
                    leveledExclusions: null,
                    leveledExclusionsBgColor: null
                });

                if (!_.some(this.leveledProposals, function (p) {
                    return p.id === proposal.id;
                })) {
                    this.leveledProposals.push(proposal);
                }

                this.renderProposals(false);
                this.queueSaveLevelingChanges();
            }, this)
        });
    },
    reapplyPreviousLeveling: function (e) {
        e.stopPropagation();

        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            proposal = this.proposals.get(proposalId);

        if (!proposal) {
            return;
        }

        let revisions = proposal.get('revisions') || [];

        let nonCurrent = _.filter(revisions, function (r) {
            return r && r.createdOn && String(r.name || '').toLowerCase() !== 'current';
        });

        let previousRevision = null;

        if (nonCurrent.length > 0) {
            let sorted = _.sortBy(nonCurrent, function (r) {
                return new Date(r.createdOn).getTime();
            });
            previousRevision = sorted[sorted.length - 1];
        }

        if (previousRevision == null) {
            return;
        }

        previousRevision = new PJQ.models.bidForms.Proposal({
            proposalId: previousRevision.proposalId
        });

        new PJQ.views.modals.YesNo({
            header: 'Reapply Previous Versions Adjustments?',
            body: 'This will reapply all adjustments from the previous version overriding any existing adjustments. This cannot be undone. Are you sure you want to do this?',
            onYes: () => {
                previousRevision.fetch({
                    success: _.bind(function () {
                        let changed = false;

                        let buildMap = function (collection, keyField) {
                            let map = {};

                            if (!collection) {
                                return map;
                            }

                            collection.each(function (model) {
                                let key = model.get(keyField);
                                if (key != null) {
                                    map[String(key)] = model;
                                }
                            });

                            return map;
                        };

                        let applyMappedFields = function (currentCollection, previousMap, keyField, fields) {
                            if (!currentCollection) {
                                return false;
                            }

                            let collectionChanged = false;

                            currentCollection.each(function (model) {
                                let key = model.get(keyField);
                                if (key == null) {
                                    return;
                                }

                                let prev = previousMap[String(key)];
                                if (!prev) {
                                    return;
                                }

                                let attrs = {};
                                let needsChange = false;

                                _.each(fields, function (field) {
                                    let newValue = prev.get(field);

                                    if (field === 'note' && !newValue) {
                                        newValue = '';
                                    }

                                    attrs[field] = newValue;

                                    let currentValue = model.get(field);
                                    if (field === 'note' && !currentValue) {
                                        currentValue = '';
                                    }

                                    if (currentValue !== newValue) {
                                        needsChange = true;
                                    }
                                });

                                if (needsChange) {
                                    collectionChanged = true;
                                    model.set(attrs, {silent: true});
                                }
                            });

                            return collectionChanged;
                        };

                        let applyProposalFields = function (currentModel, previousModel, fields) {
                            if (!currentModel || !previousModel) {
                                return false;
                            }

                            let attrs = {};
                            let needsChange = false;

                            _.each(fields, function (field) {
                                let newValue = previousModel.get(field);
                                attrs[field] = newValue;

                                if (currentModel.get(field) !== newValue) {
                                    needsChange = true;
                                }
                            });

                            if (needsChange) {
                                currentModel.set(attrs, {silent: true});
                                return true;
                            }

                            return false;
                        };

                        let levelingFields = [
                            'note',
                            'leveledBgColor',
                            'leveledCost',
                            'leveledMultiplier',
                            'leveledAnswer'
                        ];

                        let valueFields = [
                            'leveledValue',
                            'leveledBgColor'
                        ];

                        let proposalFields = [
                            'leveledInclusions',
                            'leveledInclusionsBgColor',
                            'leveledExclusions',
                            'leveledExclusionsBgColor'
                        ];

                        let prevLineItemMap = buildMap(previousRevision.lineItems, 'bidFormLineItemId'),
                            prevAlternateMap = buildMap(previousRevision.alternates, 'bidFormAlternateId'),
                            prevAcknowledgementMap = buildMap(previousRevision.acknowledgements, 'bidFormAcknowledgementId'),
                            prevProjectProposal = previousRevision.projectProposal,
                            currentProjectProposal = proposal.projectProposal,
                            prevProjectProposalAcknowledgementMap = buildMap(prevProjectProposal?.acknowledgements, 'proposalAcknowledgementId'),
                            prevBondingMap = buildMap(prevProjectProposal?.bonding, 'proposalBondingId'),
                            prevLaborRatesMap = buildMap(prevProjectProposal?.laborRates, 'proposalLaborRateId'),
                            prevCertificationsMap = buildMap(prevProjectProposal?.certifications, 'proposalCertificationId');

                        if (applyMappedFields(proposal.lineItems, prevLineItemMap, 'bidFormLineItemId', levelingFields)) {
                            changed = true;
                        }

                        if (applyMappedFields(proposal.alternates, prevAlternateMap, 'bidFormAlternateId', levelingFields)) {
                            changed = true;
                        }

                        if (applyMappedFields(proposal.acknowledgements, prevAcknowledgementMap, 'bidFormAcknowledgementId', valueFields)) {
                            changed = true;
                        }

                        if (applyMappedFields(currentProjectProposal?.acknowledgements, prevProjectProposalAcknowledgementMap, 'proposalAcknowledgementId', valueFields)) {
                            changed = true;
                        }

                        if (applyMappedFields(currentProjectProposal?.bonding, prevBondingMap, 'proposalBondingId', valueFields)) {
                            changed = true;
                        }

                        if (applyMappedFields(currentProjectProposal?.laborRates, prevLaborRatesMap, 'proposalLaborRateId', valueFields)) {
                            changed = true;
                        }

                        if (applyMappedFields(currentProjectProposal?.certifications, prevCertificationsMap, 'proposalCertificationId', valueFields)) {
                            changed = true;
                        }

                        if (applyProposalFields(proposal, previousRevision, proposalFields)) {
                            changed = true;
                        }

                        if (changed && !_.some(this.leveledProposals, function (p) {
                            return p.id === proposal.id;
                        })) {
                            this.leveledProposals.push(proposal);
                        }

                        proposal.trigger('change');
                        this.renderProposals(false);
                        this.queueSaveLevelingChanges();
                    }, this)
                });
            }
        });
    },
    alternateEnabled: function (e) {
        let $target = $(e.currentTarget),
            alternateId = $target.data('alternateId'),
            isEnabled = $target.prop('checked');
        _.each(this.proposals.models, function (proposal) {
            let propAlternate = proposal.alternates.findWhere({bidFormAlternateId: alternateId});
            if (propAlternate != null) {
                propAlternate.set('isLevel', isEnabled);
            }
        });
        let bfAlternate = this.options.bidForm.alternates.get(alternateId);
        bfAlternate.set('isLevel', isEnabled);
        this.renderProposals();
    },
    viewProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.preview(this.collection, {
            isEdit: false
        });
    },
    rejectProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        new PJQ.views.bidForms.RejectModal({
            onConfirm: _.bind(function (note) {
                selectedProp.reject(note);
                this.render();
            }, this)
        });
    },
    reviseProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.preview(this.collection, {
            isEdit: true
        });
    },
    awardProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        _.each(this.collection.models, function (proposal) {
            proposal.set({
                awardedOn: null,
                awardedBy: null,
                isAwarded: false
            });
        });
        selectedProp.award(true);
    },
    exportProposalExcelClicked: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        this.exportProposal(selectedProp);
    },
    exportProposalPDFClicked: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        this.exportProposal(selectedProp, 'pdf');
    },
    exportProposal: function (selectedProp, format = 'xlsx') {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = PJQ.app.session.project.hasPermission('bidForms.isAdmin');

        if (format?.toLowerCase() === 'pdf') {
            canViewComments = false;
        }

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: (exportLeveledProposal, exportComments) => {
                    selectedProp.export(exportLeveledProposal, exportComments, format);
                }
            });
        } else {
            selectedProp.export(false, false, format);
        }
    },
    deleteProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this proposal?  This will delete all versions of the proposal.",
            onDelete: _.bind(function () {
                selectedProp.destroy();
                this.collection.trigger('change');
            }, this)
        });
    },
    getProposalSortStorageParts: function () {
        return [
            (this.options.project && this.options.project.masterUserId != null)
                ? this.options.project.masterUserId
                : PJQ.app.session.get('masterUserId')
        ];
    },
    loadProposalSortFromStorage: function () {
        let obj = PJQ.helpers.localStorageHelpers.getJSON(
            PJQ.constants.localStorage.BID_FORM_PROPOSAL_SORT,
            this.getProposalSortStorageParts()
        ) || {};

        let sortBy = obj.sortBy || 'adjustedTotal';
        let sortDir = obj.sortDir || 'asc';

        if (sortBy !== 'adjustedTotal' && sortBy !== 'submittedTotal') {
            sortBy = 'adjustedTotal';
        }
        if (sortDir !== 'asc' && sortDir !== 'desc') {
            sortDir = 'asc';
        }

        this.sortBy = sortBy;
        this.sortDir = sortDir;
    },
    saveProposalSortToStorage: function () {
        PJQ.helpers.localStorageHelpers.setJSON(
            PJQ.constants.localStorage.BID_FORM_PROPOSAL_SORT,
            this.getProposalSortStorageParts(),
            {sortBy: this.sortBy, sortDir: this.sortDir}
        );
    },
    renderProposals: function (clearLeveledProposals = true, clearContext = true) {
        let scrollState = this.getScrollState();

        this.leveledProposals = this.leveledProposals != null && !clearLeveledProposals ? this.leveledProposals : [];
        this.contextProposal = clearContext ? null : this.contextProposal;
        this.contextLevelItem = clearContext ? null : this.contextLevelItem;

        this.proposals = this.getFilteredProposals();

        if (this.options.settings.get('isBidLevelingEnabled')) {
            this.renderSubTemplate(false, this.options.subTemplates.proposalLeveling, this.$('.proposals-inner'), {
                makeProposalItem: _.bind(this.makeProposalItem, this),
                proposals: this.proposals,
                bidForm: this.options.bidForm,
                projectBidForm: this.options.projectBidForm,
                settings: this.options.settings,
                isLeveling: this.options.isLeveling,
                sortBy: this.sortBy,
                sortDir: this.sortDir,
                showAdjustments: this.options.showAdjustments,
                isCompareMode: this.options.isCompareMode,
                compareSelectedIds: this.compareSelectedIds || [],
                hideProposalValues: this.options.isSealed && this.options.hideSealedValues
            });
        } else {
            this.$('.proposals-inner').empty();

            let $row = $('<div class="row"></div>');
            this.$('.proposals-inner').append($row);

            _.each(_.sortBy(this.proposals.models, function (model) {
                return model.get('sortOrder');
            }), function (model) {
                if (this.options.canSelect && !model.get('isSubmitted')) {
                    return;
                }

                let container = $('<div class="col-4 bid-form-proposal" data-cid="' + model.cid + '" />');
                $row.append(container);
                new PJQ.views.bidForms.Proposal({
                    model: model,
                    project: this.options.project,
                    collection: this.collection,
                    el: container,
                    settings: this.options.settings,
                    canSelect: this.options.canSelect,
                    hideProposalValues: this.options.isSealed && this.options.hideSealedValues,
                    isSelected: this.selectedIds != null && this.selectedIds.indexOf(model.id) !== -1,
                    onSelect: _.bind(function (isSelected) {
                        if (isSelected) {
                            this.selectedIds = _.union([model.id], this.selectedIds);
                        } else {
                            this.selectedIds = _.without(this.selectedIds, model.id);
                        }
                        this.exportToolbar.updateSelectedCount(_.size(this.selectedIds));
                    }, this)
                });
            }, this);
        }

        if (PJQ.app.options.initProposal != null && !PJQ.app.options.initProposal.get('isShown')) {
            let matchInitProposal = this.collection.getProposals().get(PJQ.app.options.initProposal.id);
            if (matchInitProposal == null) {
                matchInitProposal = _.find(this.collection.getProposals().models, function (prop) {
                    return _.size(prop.get('revisions')) > 0
                        && null != _.find(prop.get('revisions'), function (rev) {
                            return rev.proposalId === PJQ.app.options.initProposal.id;
                        });
                });
            }

            if (matchInitProposal != null) {
                matchInitProposal.preview(this.collection, {isEdit: false});
                PJQ.app.options.initProposal = null;
            }
        }

        this.comparePicker?.remove();
        this.comparePicker = null;

        if (this.options.isCompareMode) {
            this.comparePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.proposals-compare-select'),
                choices: this.getCompareChoices(),
                defaultValue: this.compareSelectedIds || [],
                canEdit: true,
                isMultiple: true,
                isLiveSearch: true,
                isIntChoices: true,
                noneSelectedText: 'Select Proposals',
                onChange: _.bind(function (val) {
                    let ids = val;

                    ids = _.filter(_.map(ids, function (id) {
                        return id;
                    }), function (id) {
                        return id != null;
                    });

                    ids = _.sortBy(_.uniq(ids), function (id) {
                        return id;
                    });

                    this.compareSelectedIds = ids;
                    this.renderProposals(false, false);
                }, this)
            });
        }

        let self = this;
        this.$('.proposal-item.leveled').each(function () {
            self.makeProposalItemTooltip($(this));
        });

        this.applyScrollState(scrollState);
    },
    getStatusFilter: function () {
        return this.statusFilter ? this.statusFilter : [];
    },
    getSearchFilter: function () {
        return this.search ? this.search : "";
    },
    openBiddersTab: function () {
        $('a[href="#biddersContainer"]').tab('show');
    },
    compareProposals: function () {
        new PJQ.views.bidForms.ProposalsCompareModal({
            collection: this.collection.getProposals(this.options.bidForm.id),
            settings: this.options.settings
        });
    },
    exportSelected: function () {
        this.exportProposals(this.selectedIds);
    },
    exportExcel: function () {
        this.exportProposals(null);
    },
    exportProposals: function (proposalIds, format = "xlsx") {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = PJQ.app.session.project.hasPermission('bidForms.isAdmin'),
            fnExport = (proposalIds, exportLeveledProposal, exportComments) => {
                PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'bidforms',
                        value: this.options.bidForm.id
                    },
                    {
                        endpoint: 'export'
                    }
                ], [
                    {
                        parameter: "format",
                        value: format
                    },
                    {
                        parameter: 'leveling',
                        value: exportLeveledProposal
                    },
                    {
                        parameter: 'comments',
                        value: exportComments
                    },
                    {
                        parameter: "ids",
                        value: proposalIds
                    }
                ]));
            };

        if (format?.toLowerCase() === 'pdf') {
            canViewComments = false;
        }

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: (exportLeveledProposal, exportComments) => {
                    fnExport(proposalIds, exportLeveledProposal, exportComments);
                }
            });
        } else {
            fnExport(proposalIds, false, false);
        }

    }
});

PJQ.views.bidForms.Proposal = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal'),
        subTemplates: {
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input')
        },
        canSelect: false,
        onSelect: null,
        isSelected: false
    },
    events: {
        "click .proposal-review-button": "reviewProposal",
        "click .proposal-edit-button": "editProposal",
        "click .btn-export-proposal": "exportProposal",
        "change .cb-proposal": "selectProposal",
        "click .btn-line-item-comments": "viewComments",
        "click .btn-alternate-comments": "viewComments"
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
        this.model.on("sync", this.render, this);
    },
    renderData: function () {
        let isLowestProposal = false,
            isLowestProposalWithAlternates = false,
            lowestProposal = this.collection.getLowestProposal(this.model.get('bidFormId'), false),
            lowestProposalWithAlternates = this.collection.getLowestProposal(this.model.get('bidFormId'), true);

        if (lowestProposal && lowestProposal.id === this.model.id)
            isLowestProposal = true;
        if (lowestProposalWithAlternates && lowestProposalWithAlternates.id === this.model.id)
            isLowestProposalWithAlternates = true;
        return {
            proposal: this.model,
            canEdit: this.options.canEdit,
            isLowestProposal: isLowestProposal,
            isLowestProposalWithAlts: isLowestProposalWithAlternates,
            helpers: PJQ.helpers,
            settings: this.options.settings,
            canSelect: this.options.canSelect,
            hideProposalValues: this.options.hideProposalValues,
            getItemInput: _.bind(this.getItemInput, this),
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            canAddComments: PJQ.app.session.project.hasPermission('bidForms.canAddComments')
        };
    },
    afterRender: function () {
        this.$('.proposals-container').sortable({
            items: '.bid-form-proposal',
            connectWith: '.bid-form-proposal'
        });

    },
    reviewProposal: function () {
        this.model.preview(this.collection, {
            isEdit: false
        });
    },
    editProposal: function () {
        this.model.preview(this.collection, {
            isEdit: true
        });
    },
    exportProposal: function () {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: _.bind(function (exportLeveledProposal, exportComments) {
                    this.model.export(exportLeveledProposal, exportComments);
                }, this)
            });
        } else {
            this.model.export(false, false);
        }
    },
    selectProposal: function () {
        if (typeof this.options.onSelect === 'function') {
            this.options.onSelect(this.$('.cb-proposal').prop('checked'));
        }
    },
    getItemInput: function (model) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: false,
            helpers: PJQ.helpers
        });
    },
    viewComments: function (event) {
        let el = $(event.currentTarget).parent(),
            cid = $(event.currentTarget).data('cid'),
            isLineItem = $(event.currentTarget).hasClass('btn-line-item-comments'),
            item = isLineItem ? this.model.lineItems.get(cid) : this.model.alternates.get(cid);

        new PJQ.views.bidForms.ProposalItemEditModal({
            item: item,
            onSave: _.bind(function () {
                var comments = _.filter(item.comments.models, function (comment) {
                        return !comment.get('isDeleted');
                    }),
                    $commentButton = el.find('.btn-line-item-comments'),
                    $commentButtonIcon = el.find('.btn-line-item-comments i'),
                    tooltip = 'No';

                if (comments.length > 0) {
                    tooltip = comments.length.toString();

                    $commentButton.removeClass('btn-transparent-dark').addClass('btn-light');
                    $commentButtonIcon.removeClass('text-muted').addClass('text-dark');
                } else {
                    $commentButton.removeClass('btn-light').addClass('btn-transparent-dark');
                    $commentButtonIcon.removeClass('text-dark').addClass('text-muted');
                }

                tooltip = tooltip + ' Comment' + (comments.length != 1 ? 's' : '');
                $commentButton.attr('title', tooltip);

                // if we're not in edit mode, we have to manually save changes to the comments.
                if (!this.options.isEdit && _.some(item.comments.models, function (model) {
                    return (!model.get('proposalLineItemCommentId') && isLineItem) || (!model.get('proposalAlternateCommentId') && !isLineItem) || model.get('isDeleted');
                })) {
                    item.comments.save({
                        success: _.bind(function (data) {
                            item.comments.reset(data);
                            PJQ.notifications.notify.successNotify({
                                message: 'Comments updated successfully'
                            });
                        }, this),
                        error: _.bind(function () {
                            PJQ.notifications.notify.errorNotify({
                                message: 'Comment update failed'
                            });
                        }, this)
                    });
                }
            }, this)
        });

    }
});

PJQ.views.bidForms.ProposalsCompareModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Proposals-Compare'),
        compareProposals: []
    },
    events: {
        "click .proposal-compare": "compareProposalClick"
    },
    renderData: function () {
        return {
            lowestProposal: this.collection.getLowestProposal(false),
            lowestProposalWithAlternates: this.collection.getLowestProposal(true),
            helpers: PJQ.helpers,
            collection: this.collection,
            settings: this.options.settings,
            compareProposals: this.getCompareProposals()
        };
    },
    afterRender: function () {
        new PJQ.views.bidForms.ProposalsCompare({
            el: this.$('.proposals-compare'),
            collection: this.getCompareProposals(),
            settings: this.options.settings
        });
    },
    getCompareProposals: function () {
        return new PJQ.collections.bidForms.Proposals(this.options.compareProposals);
    },
    compareProposalClick: function (e) {
        let cid = $(e.currentTarget).closest('.proposal-select').data('cid');
        this.compareProposal(this.collection.get({cid: cid}));
    },
    compareProposal: function (proposal) {
        if (_.findWhere(this.options.compareProposals, {cid: proposal.cid})) {
            this.options.compareProposals = _.filter(this.options.compareProposals, function (compareProposal) {
                return proposal.cid !== compareProposal.cid;
            })
        } else {
            this.options.compareProposals.push(proposal);
        }
        this.render();
    }
});

PJQ.views.bidForms.ProposalsCompare = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposals-Compare'),
        subTemplates: {
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input')
        }
    },
    events: {
        "click .proposal-edit-button": "editProposal"
    },
    renderData: function () {
        return {
            lowestProposal: this.collection.getLowestProposal(false),
            lowestProposalWithAlternates: this.collection.getLowestProposal(true),
            getItemInput: _.bind(this.getItemInput, this),
            helpers: PJQ.helpers,
            collection: this.collection,
            settings: this.options.settings
        };
    },
    reviewProposal: function () {
        this.model.preview(this.collection, {
            isEdit: false
        });
    },
    getItemInput: function (model) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: false,
            helpers: PJQ.helpers
        });
    }
});

PJQ.views.bidForms.RejectModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'modal-reject-proposal'),
        onConfirm: null
    },
    events: {
        'click .btn-confirm': 'confirm'
    },
    confirm: function () {
        let rejectNote = this.$(".reject-note").val();
        if (typeof this.options.onConfirm === 'function') {
            this.options.onConfirm(rejectNote);
        }
        this.removeModal();
    }
});

PJQ.views.bidForms.ExportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'modal-export-proposals'),
        isBidLevelingEnabled: false,
        canViewComments: false,
        onExport: null
    },
    events: {
        'click .btn-export': 'exportProposals'
    },
    beforeModalCreated: function () {
        this.exportLeveledProposal = true;
        this.exportComments = false;
    },
    renderData: function () {
        return {
            isBidLevelingEnabled: this.options.isBidLevelingEnabled,
            canViewComments: this.options.canViewComments,
            exportLeveledProposal: this.exportLeveledProposal,
            exportComments: this.exportComments
        };
    },
    exportProposals: function () {
        this.exportComments = this.$('.input-export-comments').prop('checked');
        this.exportLeveledProposal = this.$('.input-export-adjustments').prop('checked');
        if (typeof this.options.onExport === 'function') {
            this.options.onExport(this.exportLeveledProposal && this.options.isBidLevelingEnabled, this.exportComments && this.options.canViewComments);
        }
        this.removeModal();
    }
});

